import {debounce, outerHeight} from '../helpers/helpers.js'

export function setElHeightVariables() {

  function setViewportHeight() {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = vh = window.innerHeight * 0.01 || document.documentElement.clientHeight * 0.01
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', vh + 'px')
  }
  setViewportHeight()

  function setHeaderHeight() {
    const header = document.querySelector('#header')
    if (!header) return
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let headerHeight = header.offsetHeight
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px')
  }
  setHeaderHeight()
  
  function setProjectFilterHeight() {
    const filter = document.querySelector('[data-project-filter]')
    if (!filter) return
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let filterHeight = filter.offsetHeight
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--projectFilterHeight', filterHeight + 'px')
  }
  setProjectFilterHeight()

  function setArticleFilterHeight() {
    const filter = document.querySelector('[data-article-filter]')
    if (!filter) return
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let filterHeight = filter.offsetHeight
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--articleFilterHeight', filterHeight + 'px')
  }
  setArticleFilterHeight()

  function setProjectFeedHeight() {
    const filter = document.querySelector('.o-section--projects-filter')
    const footer = document.querySelector('[data-project-footer]')
    const feed = document.querySelector('[data-project-feed]')
    if (!feed) return
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let filterHeight = outerHeight(filter)
    let footerHeight = footer.offsetHeight
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--projectFeedHeightDeduction', (filterHeight+footerHeight) + 'px')
  }
  setProjectFeedHeight()


  function update() {
    var timeout
      
    // If there's a timer, cancel it
    if (timeout) {
      window.cancelAnimationFrame(timeout)
    }

    // Setup the new requestAnimationFrame()
    timeout = window.requestAnimationFrame(function () {
      // We execute the same script as before
      setViewportHeight()
      setHeaderHeight()
      setProjectFilterHeight()
      setArticleFilterHeight()
    }) 
  }

  // Wait until innerheight changes, for max 120 frames
  function orientationChanged() {
    const timeout = 120
    return new window.Promise(function(resolve) {
      const go = (i, height0) => {
        window.innerHeight != height0 || i >= timeout ?
          resolve() :
          window.requestAnimationFrame(() => go(i + 1, height0))
      }
      go(0, window.innerHeight)
    })
  }

  const debounceInst = debounce(() => update(), 250)

  // Listen to the resize event if not a touch device
  if (! document.body.classList.contains("is-mobile")) {
    window.addEventListener("resize", debounceInst)
  }

  // listen to the orientationchange event if a touch device
  if (document.body.classList.contains("is-mobile")) {
    window.addEventListener("orientationchange", () => {
      orientationChanged().then(function() {
        update()
      })
    }, true)
  }

}